import { render, staticRenderFns } from "./BranchForm.vue?vue&type=template&id=ec6a5774&"
import script from "./BranchForm.vue?vue&type=script&lang=ts&"
export * from "./BranchForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports